import React from 'react'
import { Divider, Grid, IconButton, useTheme } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import moment from 'moment'

import NoRecordFound from '../NoRecordFound'
import ImageComponent from '../ImageComponent'
import { TextBold, TextRegular } from '../TextStyling'
import { currencySymbol } from '../../utils/AppConstants'
import { formatNumber } from '../../utils/AppHelper'

export default function EarningsList () {
  const location = useLocation()
  const navigate = useNavigate()
  const theme = useTheme()

  const { rowData, payment } = location.state || []
  const todaysDate = moment() // Today's date as a moment object

  const handleBackClick = () => navigate('/recruiter/referralearning')

  const renderTransactionInfo = item => {
    if (!item.leftOutDate && item.transactionId) {
      return (
        <>
          <Grid item>
            <TextRegular
              style={{ color: theme.palette.text.disabled, fontSize: '12px' }}
            >
              Transaction ID
            </TextRegular>
          </Grid>
          <Grid item>
            <TextRegular style={{ fontSize: '12px' }}>
              {item.transactionId}
            </TextRegular>
          </Grid>
        </>
      )
    }
    return (
      <>
        <Grid item>
          <TextRegular
            style={{ color: theme.palette.text.disabled, fontSize: '12px' }}
          >
            {!moment(item.dueOn).isBefore(todaysDate, 'day') &&
              !item.leftOutDate &&
              'Due Date:'}
            {item.leftOutDate && 'Left out date:'}
          </TextRegular>
        </Grid>
        <Grid item>
          <TextRegular style={{ fontSize: '12px' }}>
            {!moment(item.dueOn).isBefore(todaysDate, 'day') &&
              !item.leftOutDate &&
              moment(item.dueOn).format('dddd, MMMM Do YYYY')}
            {item.leftOutDate &&
              moment(item.leftOutDate).format('dddd, MMMM Do YYYY')}
          </TextRegular>
        </Grid>
      </>
    )
  }

  const renderStatus = item => {
    if (item.leftOutDate) return 'Not earnings'
    if (item.paymentStatus === 'paid') return 'Earned'
    return 'To be earned'
  }

  const renderAmount = item => {
    return item.paymentStatus === 'paid'
      ? formatNumber(item.amountPaid)
      : formatNumber(item.amountToPay)
  }

  const renderStatusBadge = item => {
    if (item.paymentStatus === 'paid' && !item.leftOutDate) {
      return (
        <Grid
          item
          style={{
            background: theme.palette.text.success,
            padding: '4px 16px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <TextRegular
            style={{ color: theme.palette.background.paper, fontSize: '12px' }}
          >
            Paid
          </TextRegular>
        </Grid>
      )
    }
    if (item.leftOutDate) {
      return (
        <Grid
          item
          style={{
            background: theme.palette.text.error,
            padding: '4px 16px',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <TextRegular
            style={{ color: theme.palette.background.paper, fontSize: '12px' }}
          >
            Cancelled
          </TextRegular>
        </Grid>
      )
    }
    return null
  }

  return (
    <Grid container>
      {/* Header Section */}
      <Grid item xs={12}>
        <Grid
          container
          style={{
            position: 'absolute',
            top: '4rem',
            background: theme.palette.background.paper,
            left: '0px',
            padding: '8px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Grid item>
            <IconButton onClick={handleBackClick}>
              <ArrowBackIcon style={{ fontSize: '16px' }} />
            </IconButton>
          </Grid>
          <Grid item style={{ marginLeft: '16px' }}>
            Earning list
          </Grid>
        </Grid>
      </Grid>

      {/* Earnings List Section */}
      <Grid item xs={12} style={{ marginTop: '3rem' }}>
        <Grid
          container
          style={{
            position: 'absolute',
            top: '8rem',
            background: theme.palette.background.paper,
            left: '0px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          {rowData.length > 0 ? (
            rowData.map((item, index) => (
              <React.Fragment key={index}>
                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex' }}
                  onClick={() =>
                    navigate('/recruiter/earningDetails', {
                      state: { item, list: rowData, payment }
                    })
                  }
                >
                  <Grid item xs={8} style={{ padding: '12px' }}>
                    <Grid
                      item
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Grid
                        item
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: '32px',
                          borderRadius: '8px',
                          overflow: 'hidden',
                          objectFit: 'contain',
                          alignItems: 'center',
                          marginRight: '12px'
                        }}
                      >
                        <ImageComponent
                          alt='company logo'
                          src={item.profilePicture}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                      <Grid item>
                        <TextRegular style={{ fontSize: '16px' }}>
                          {item.companyname}
                        </TextRegular>
                      </Grid>
                    </Grid>
                    {renderTransactionInfo(item)}
                  </Grid>

                  <Grid item xs={4} style={{ padding: '12px' }}>
                    <Grid
                      container
                      style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <Grid
                        item
                        xs={11}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-end',
                          flexDirection: 'column',
                          paddingRight: '8px'
                        }}
                      >
                        <Grid item xs={12}>
                          <TextRegular
                            style={{
                              color: theme.palette.text.disabled,
                              fontSize: '12px'
                            }}
                          >
                            {renderStatus(item)}
                          </TextRegular>
                        </Grid>
                        <Grid item xs={12}>
                          <TextBold>
                            {currencySymbol}
                            {renderAmount(item)}
                          </TextBold>
                        </Grid>
                        {renderStatusBadge(item)}
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <ArrowForwardIosIcon
                          style={{
                            color: theme.palette.text.disabled,
                            fontSize: '14px'
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider style={{ width: '100%' }} />
              </React.Fragment>
            ))
          ) : (
            <NoRecordFound />
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
